module.exports = __webpack_public_path__ + "../front/img/568_trådkurv+hylder+bøjlestang.77abfcd1.svg";